import { useState } from "react";
import ImageWithFallback from "@components/ui/ImageFallback";
import MealDescriptionPage from "@features/diet/RecipieDetails";
import { Link, useNavigate } from "react-router-dom";
import MealDescriptionModal from "@features/diet/RecipieDetails";
import { ReactComponent as Diamond } from "@assets/images/diamontBullet.svg";
import { useTranslation } from "react-i18next";
const SnacksDetails = ({
  mealType,
  meal,
  mealKey,
  selectedMeal,
  mealSelection = false,
}) => {
  //   const [open, setOpen] = useState(false);
  //   const handleOpenRecipie = () => {
  //     setOpen(true);
  //   };
  const BASE_URL = process.env.REACT_APP_BACKEND_BASE_URL;
  const { t } = useTranslation();

  return (
    <div className="p-2 rounded-lg overflow-auto max-h-[100%] md:flex md:justify-center">
      <div
        className="max-w-[100%] min-w-[100%] xl:max-w-[60%] xl:min-w-[60%] md:p-[22px] flex flex-col gap-3 border border-[2px] border-[#F2F2F2B8] rounded-[10px] p-5 bg-[linear-gradient(150deg,_#0771EF_12.89%,_#15AAFC_85.22%)]"
        style={{
          boxShadow: "0px 4px 4px 0px #0000000D",
        }}
      >
        <div
          className="grid md:grid-cols-2  gap-4 md:gap-8"
          style={{
            background:
              "linear-gradient(150deg, #0771EF 12.89%, #15AAFC 85.22%)",
          }}
        >
          <ImageWithFallback
            src={`${
              mealSelection
                ? selectedMeal.images?.[mealKey]
                : selectedMeal.image?.[mealKey]
            }`}
            alt={"image"}
            width={"106px"}
            height={"106px"}
            className="min-w-[100%] min-h-[183px] max-h-[183px] rounded-lg object-cover  mb-3 md:mb-0"
          />
          <div className="">
            <p className="text-[24px] text-white font-[600] font-Lato mb-2">
              {" "}
              {/* {mealType} */}
              {t(`weeklyMealDetails.${mealType}`)}
            </p>
            <div className="border border-[#DADADA] p-3 rounded-[10px] bg-white">
              {meal.SnackItems?.map((item) => {
                return (
                  <p className="text-sm text-[#262626] flex items-center gap-2">
                    <Diamond className="min-w-3 min-h-3 max-w-3 max-h-3" />
                    {item}
                  </p>
                );
              })}
              <p className="text-sm text-[#262626] flex items-center gap-2">
                <Diamond className="min-w-3 min-h-3 max-w-3 max-h-3" />
                <span className="">Calories:</span> {meal.Calories} kcal
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SnacksDetails;
